export const MARITAL_STATUS_OPTIONS = [
  "Solteiro(a)",
  "Casado(a)",
  "Divorciado(a)",
  "Viúvo(a)",
  "União estável",
  "Separado(a)",
] as const;

export type MaritalStatus = (typeof MARITAL_STATUS_OPTIONS)[number];
